export default {
  Title: 'New user',
  Form: {
    FirstName: {
      Title: 'First Name',
      Example: 'First Name',
      FormFeedback: 'Name must be between 1-15 letters',
    },
    LastName: {
      Title: 'Last Name',
      Example: 'Last Name',
      FormFeedback: 'Name must be between 1-15 letters',
    },
    Email: {
      Title: 'Email',
      Example: 'example@example.com',
      FormFeedback: 'Please input a correct email',
    },
  },
  UserAlreadyExist: 'This email is already active in the system',
};
